import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { goToPage } from '../../WifiManagementBlockSlice';
import homeIcon from './images/home-icon.svg';
import guestIcon from './images/guest-icon.svg';
import plusIcon from './images/plus-icon.svg';

const ChooseNetworkPage = (props) => {

    useEffect(() => {

    }, []);

    return (
        <div className='choose-network-page'>
            <div className='title'> רשתות ה WI-FI שלך </div>

            <div className='network-items-wrapper'>

                <a className='network-item' href='#' onClick={(e) => props.goToPage('homeNetworkPage')}>
                    <div className='home-icon' style={{backgroundImage:homeIcon.bg()}}></div>
                    <div className='network-title'> רשת ביתית </div>
                </a>

                {
                    hasGuestWifi() ? (
                        <a className='network-item' href='#' onClick={(e) => props.goToPage('guestNetworkPage')}>
                            <div className='guest-icon' style={{backgroundImage:guestIcon.bg()}}></div>
                            <div className='network-title'> רשת אורחים </div>
                        </a>
                    ) : (
                        <a className='network-item' href='#' onClick={(e) => props.goToPage('guestNetworkInfoPage')}>
                            <div className='plus-icon' style={{backgroundImage:plusIcon.bg()}}></div>
                            <div className='network-title'> רשת אורחים </div>
                        </a>  
                    )
                }

            </div>
          
            {
                !hasGuestWifi() &&
                <div className='bottom-text-wrapper'>
                    <div className='bottom-title'> הגדרת רשת אורחים </div>
                    <div className='bottom-text'> רשת אורחים מאפשרת למבקרים שלך לגשת לאינטרנט מבלי לחשוף את הרשת הראשית שלך, בכך שומרת על ה-Wi-Fi הביתי והנתונים האישיים שלך בטוחים </div>
                </div>
            }

        </div>
    );


    function hasGuestWifi() {
        if (!props.guestNetworks) { return false; }
        const guestWifi = props.guestNetworks.find(x=> x.networkType.startsWith('WIFIG'));
        return !!guestWifi;
    }
    
};

const mapStateToProps = (state) => {
    return {
        guestNetworks: state.wifiManagementBlock?.networkWiFis.filter(x=> x.type == 'Guest' && x.networkExists)
    };
};

const mapDispatchToProps = {
    goToPage
};

export default connect(mapStateToProps, mapDispatchToProps)(ChooseNetworkPage);